//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Checkbox from '@/components/checkbox/Checkbox.vue'
import Button from '@/components/button/Button.vue'

export default {
  name: 'FilterModal',

  components: {
    Checkbox,
    Button,
  },

  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    priceOptions: {
      type: Array,
      required: true,
    },
    categoryOptions: {
      type: Array,
      default: () => [],
    },
    selectedPrices: {
      type: Array,
      required: true,
    },
    selectedCategories: {
      type: Array,
      default: () => [],
    },
    hitCount: {
      type: Number,
      required: true,
    },
    showCategoryBlock: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      // モーダル編集中の条件（親の確定状態とは分離）
      localSelectedPrices: [],
      localSelectedCategories: [],
      // 初期同期時の emit ループ防止
      isMutingEmit: false,
    }
  },

  computed: {
    isVisible: {
      get() {
        return this.visible
      },
      set(value) {
        this.$emit('update:visible', value)
      },
    },

    hasSelectedConditions() {
      return (
        this.localSelectedPrices.length > 0 ||
        this.localSelectedCategories.length > 0
      )
    },

    hasPriceBlock() {
      return this.priceOptions && this.priceOptions.length > 0
    },

    hasCategoryBlock() {
      return this.showCategoryBlock && this.categoryOptions.length > 0
    },

    visibleBlockCount() {
      let count = 0
      if (this.hasPriceBlock) count++
      if (this.hasCategoryBlock) count++
      return count
    },
  },

  // 親は確定状態、子はモーダル編集中の状態を保持する。
  // モーダル表示時のみ親の状態をローカル状態へ同期する。
  watch: {
    visible(newVal) {
      if (newVal) {
        this.isMutingEmit = true
        this.localSelectedPrices = [...this.selectedPrices]
        this.localSelectedCategories = [...this.selectedCategories]
        this.$nextTick(() => {
          this.isMutingEmit = false
        })
      }
    },

    localSelectedPrices() {
      this.emitConditionsChange()
    },

    localSelectedCategories() {
      this.emitConditionsChange()
    },
  },

  methods: {
    emitConditionsChange() {
      // 初期化中は親へ通知しない
      if (this.isMutingEmit) {
        return
      }

      this.$emit('conditions-change', {
        prices: [...this.localSelectedPrices],
        categories: [...this.localSelectedCategories],
      })
    },

    // 条件をクリアし、最後に1回だけ conditions-change を通知
    handleClear() {
      this.isMutingEmit = true
      this.localSelectedPrices = []
      this.localSelectedCategories = []
      this.$nextTick(() => {
        this.isMutingEmit = false
        this.emitConditionsChange()
      })
    },

    handleApply() {
      this.$emit('apply', {
        prices: [...this.localSelectedPrices],
        categories: [...this.localSelectedCategories],
      })
    },
  },
}
